<template>
  <div>
    <div class="header">
      <div class="session-id">
        <div class="iconBox">
          <v-icon>mdi-lightning-bolt</v-icon>
        </div>
        <div>
          <div class="title">
            Session #{{ selectedRow?.id }}
          </div>
          <div class="sub-title">
            {{ selectedRow?.charge_point_id }}/{{ selectedRow?.connector_id }}
          </div>
        </div>
      </div>
      <div>
        <!-- <v-btn
          color="gray"
          outlined
          class="mx-2"
        >
          Export
        </v-btn> -->
        <download-file-buttons
          v-if="downloadOpt.length > 0"
          :small="false"
          :items="downloadOpt"
          @click="downloadFileOf"
        />
      </div>
    </div>
    <div clas>
      <v-tabs v-model="tab">
        <v-tab
          v-for="tabItem in tabOptions"
          :key="tabItem.tab"
        >
          {{ tabItem.tab }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="item in tabOptions"
          :key="item.tab"
        >
          <div class="mt-5">
            <div v-if="item.content == 'overview'">
              <overview-tab
                :ref="item.content"
                :item="selectedRow"
              />
            </div>
            <div v-else-if="item.content == 'energy_detail'">
              <energy-detail-tab
                :ref="item.content"
                :item="energyData"
              />
            </div>
            <div v-else-if="item.content == 'billing'">
              <billing-tab
                :ref="item.content"
                :item="selectedRow"
              />
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {
    DownloadFileButtons: () =>
      import("@/components/base/DownloadFileButtons.vue"),
    OverviewTab: () => import("../utils/OverviewTab.vue"),
    EnergyDetailTab: () => import("../utils/EnergyDetailTab.vue"),
    BillingTab: () => import("../utils/BillingTab"),
  },
  props: {
    selectedRow: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tab: null,

      pdfLogo: require("@/assets/brandLogo/pdfLogo.png"),

      tabOptions: [
        {
          tab: this.$t("overview"),
          content: "overview",
        },
        {
          tab: this.$t("energy_detail"),
          content: "energy_detail",
        },
        {
          tab: this.$t("billing"),
          content: "billing",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      isEnergy: "csmsChargingSession/getLoading",
      energyData: "csmsChargingSession/getEnergyData",
    }),
    selectedTab() {
      return this.tabOptions[this.tab]?.content;
    },
    downloadOpt() {
      const q = this.tabOptions[this.tab]?.content;
      if (q == "overview") return ["pdf"];
      else if (q == "energy_detail") return ["pdf"];
      else if (q == "billing") return ["csv", "excel", "pdf"];
      else return [];
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
     async fetchData() {
      const params ={
        id : this.selectedRow?.id,
      }
      await this.$store.dispatch("csmsChargingSession/energyData", params)

    },
    downloadFileOf(v) {
      let { downloadFile } = this.$refs[this.selectedTab][0];
      downloadFile(v);
    },
  },
};
</script>
<style lang="sass" scoped>
.header
  margin-bottom: 1rem
  display: flex
  justify-content: space-between
  align-items: baseline
  .session-id
    display: flex
    align-items: center
    gap: 1rem
    .iconBox
      background: #dcdcdc
      padding: 1rem
      border-radius: 100%
    .title
      font-size: 20px !important
      font-weight: 600 !important
</style>
